// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-panel {
    position: fixed;
    bottom: 0px;
    right: 24px;
    z-index: 40;
    width: 25%;
    height: 80vh;
    background: white;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    border: 1px solid #e5e7eb;
    animation: slide-up 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.chat-header {
    padding: 16px;
    background: linear-gradient(135deg, #3B82F6, #2563EB);
    color: white;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.assistant-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.assistant-avatar {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sparkles-icon {
    width: 16px;
    height: 16px;
}

.assistant-text h3 {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}

.assistant-text p {
    font-size: 12px;
    opacity: 0.8;
    margin: 0;
}

.close-button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.2);
}

.close-button svg {
    width: 16px;
    height: 16px;
}

.messages-area {
    flex: 1 1;
    padding: 16px;
    background: linear-gradient(180deg, #ffffff, #f9fafb);
    overflow-y: auto;
}

.messages-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.welcome-message {
    text-align: center;
    padding: 32px 0;
}

.welcome-icon {
    width: 48px;
    height: 48px;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 12px;
}

.welcome-icon svg {
    width: 24px;
    height: 24px;
    color: #3B82F6;
}

.welcome-message p {
    color: #6b7280;
    font-size: 14px;
    margin: 0;
}

/* Questions Section */
.questions-section {
    border-top: 1px solid #e5e7eb;
    background: white;
    max-height: 160px;
    overflow-y: auto;
}

.questions-header {
    padding: 12px 16px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.5);
}

.questions-header h4 {
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0;
}

.questions-content {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* Input Area */
.chat-input-area {
    padding: 16px;
    border-top: 1px solid #e5e7eb;
    background: white;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
}

.input-container {
    display: flex;
    gap: 8px;
}

.message-input {
    flex: 1 1;
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
}

.message-input:focus {
    border-color: #3B82F6;
}

.message-input:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.send-button {
    background: #3B82F6;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.send-button:hover:not(:disabled) {
    background: #2563EB;
}

.send-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.send-button svg {
    width: 16px;
    height: 16px;
}

/* Animations */
@keyframes slide-up {
    0% {
        transform: translateY(100%);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.reduce-button {
    background: transparent;
    border: none;
    cursor: pointer;
    margin-left: 8px;
    display: flex;
    align-items: center;
}

.chat-panel.minimized {
    height: auto;
    overflow: hidden;
}

@keyframes fade-in {
    0% {
        opacity: 0;
        transform: scale(0.95);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.spinner {
    border: 3px solid #f3f3f3;
    border-top: 3px solid #555;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 0.7s linear infinite;
    display: inline-block;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ChatPanel.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,iDAAiD;IACjD,yBAAyB;IACzB,qDAAqD;IACrD,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qDAAqD;IACrD,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA,sBAAsB;AACtB;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,eAAe;AACf;IACI,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,eAAe;AACf;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC","sourcesContent":[".chat-panel {\r\n    position: fixed;\r\n    bottom: 0px;\r\n    right: 24px;\r\n    z-index: 40;\r\n    width: 25%;\r\n    height: 80vh;\r\n    background: white;\r\n    border-radius: 16px 16px 0 0;\r\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n    border: 1px solid #e5e7eb;\r\n    animation: slide-up 0.4s cubic-bezier(0.4, 0, 0.2, 1);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n\r\n.chat-header {\r\n    padding: 16px;\r\n    background: linear-gradient(135deg, #3B82F6, #2563EB);\r\n    color: white;\r\n    border-top-left-radius: 16px;\r\n    border-top-right-radius: 16px;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.assistant-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.assistant-avatar {\r\n    width: 32px;\r\n    height: 32px;\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.sparkles-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n.assistant-text h3 {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    margin: 0;\r\n}\r\n\r\n.assistant-text p {\r\n    font-size: 12px;\r\n    opacity: 0.8;\r\n    margin: 0;\r\n}\r\n\r\n.close-button {\r\n    background: none;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 4px;\r\n    border-radius: 4px;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.close-button:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.close-button svg {\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n.messages-area {\r\n    flex: 1;\r\n    padding: 16px;\r\n    background: linear-gradient(180deg, #ffffff, #f9fafb);\r\n    overflow-y: auto;\r\n}\r\n\r\n.messages-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n}\r\n\r\n.welcome-message {\r\n    text-align: center;\r\n    padding: 32px 0;\r\n}\r\n\r\n.welcome-icon {\r\n    width: 48px;\r\n    height: 48px;\r\n    background: rgba(59, 130, 246, 0.1);\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0 auto 12px;\r\n}\r\n\r\n.welcome-icon svg {\r\n    width: 24px;\r\n    height: 24px;\r\n    color: #3B82F6;\r\n}\r\n\r\n.welcome-message p {\r\n    color: #6b7280;\r\n    font-size: 14px;\r\n    margin: 0;\r\n}\r\n\r\n/* Questions Section */\r\n.questions-section {\r\n    border-top: 1px solid #e5e7eb;\r\n    background: white;\r\n    max-height: 160px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.questions-header {\r\n    padding: 12px 16px;\r\n    border-bottom: 1px solid rgba(229, 231, 235, 0.5);\r\n}\r\n\r\n.questions-header h4 {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: #6b7280;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.05em;\r\n    margin: 0;\r\n}\r\n\r\n.questions-content {\r\n    padding: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n/* Input Area */\r\n.chat-input-area {\r\n    padding: 16px;\r\n    border-top: 1px solid #e5e7eb;\r\n    background: white;\r\n    border-bottom-left-radius: 16px;\r\n    border-bottom-right-radius: 16px;\r\n}\r\n\r\n.input-container {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.message-input {\r\n    flex: 1;\r\n    padding: 12px 16px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    outline: none;\r\n    transition: border-color 0.2s;\r\n}\r\n\r\n.message-input:focus {\r\n    border-color: #3B82F6;\r\n}\r\n\r\n.message-input:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.send-button {\r\n    background: #3B82F6;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    padding: 12px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.send-button:hover:not(:disabled) {\r\n    background: #2563EB;\r\n}\r\n\r\n.send-button:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.send-button svg {\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n/* Animations */\r\n@keyframes slide-up {\r\n    0% {\r\n        transform: translateY(100%);\r\n        opacity: 0;\r\n    }\r\n    100% {\r\n        transform: translateY(0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.reduce-button {\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    margin-left: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.chat-panel.minimized {\r\n    height: auto;\r\n    overflow: hidden;\r\n}\r\n\r\n@keyframes fade-in {\r\n    0% {\r\n        opacity: 0;\r\n        transform: scale(0.95);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.spinner {\r\n    border: 3px solid #f3f3f3;\r\n    border-top: 3px solid #555;\r\n    border-radius: 50%;\r\n    width: 18px;\r\n    height: 18px;\r\n    animation: spin 0.7s linear infinite;\r\n    display: inline-block;\r\n}\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
